import { render, staticRenderFns } from "./CardSet.vue?vue&type=template&id=1f3e3470&scoped=true"
import script from "./CardSet.vue?vue&type=script&lang=js"
export * from "./CardSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3e3470",
  null
  
)

export default component.exports